<template>
    <div class="custom-select-one relative flex align-items-center gap-2">
        <CustomLabel :name="name" :label="label" :required="required" />
        <Dropdown :id="name" :options="internalItems" :optionLabel="itemLabel"
                  :optionValue="itemValue" :disabled="disabled"
                  @change="onChange" :rules="rules" :showClear="showClear"
                  v-model="internalValue" :placeholder="computedPlaceholder"
                  :filter="filter" />
        <CustomValidationMessage :errorMessage="errorMessage" />
        <CustomValidationMessage :errorMessage="customErrorMessage" />
    </div>
</template>

<script>
    import Dropdown from "primevue/dropdown";
    import {useField} from "vee-validate";
    import CustomLabel from "./CustomLabel";
    import CustomValidationMessage from "./CustomValidationMessage";
    import {watch} from 'vue';

    export default {
        name: "CustomSelectOne",
        props: {
            name: {
                type: String,
            },
            label: {
                type: String,
            },
            itemLabel: {
                default: "label",
            },
            itemValue: {
                type: String,
                default: "",
            },
            disabled: {
                type: Boolean,
                default: false,
            },
            emptyValue: {
                type: Boolean,
                default: false,
            },
            items: {
                type: Array,
            },
            required: {
                type: Boolean,
                default: false,
            },
            modelValue: null,
            rules: undefined,
            placeholder: {
                type: String,
                default: "",
            },
            noPlaceholder: {
                type: Boolean,
                default: false,
            },
            showClear: {
                type: Boolean,
                default: true,
            },
            customErrorMessage: {
                type: String,
                default: "",
            },
            filter: {
                type: Boolean,
                default: false,
            },
        },

        emits: ["update:modelValue", "change"],

        data() {
            return {
                internalItems: this.items,
                selectedValue: null,
            };
        },

        // mounted() {
        //     if (this.emptyValue) {
        //         this.internalItems = [{value: null, label: this.$t("message.other.emptyValue")}, ...this.items];
        //     }
        // },

        computed: {
            internalValue: {
                get() {
                    return this.modelValue;
                },
                set(value) {
                    this.$emit("update:modelValue", value);
                },
            },

            computedPlaceholder() {
                if (this.noPlaceholder) return "";
                if (this.placeholder === "") return this.$t('message.inputs.selectOnePlaceholder');
                else return this.placeholder;
            },
        },

        methods: {
            onChange(val) {
                if (val && val.value) {
                    this.handleChange(val.originalEvent);
                    this.$emit("change", val.value);
                } else {
                    this.handleChange(undefined);
                    this.$emit("change", undefined);
                }
            },
        },

        components: {Dropdown, CustomLabel, CustomValidationMessage},

        setup(props) {
            const {
                value: inputValue,
                errorMessage,
                handleBlur,
                handleChange,
                meta,
                setValue,
            } = useField(props.name, props.rules, {
                initialValue: props.modelValue,
            });

            watch(
                () => props.modelValue,
                (newValue) => {
                    setValue(newValue);
                }
            );

            return {
                handleChange,
                handleBlur,
                errorMessage,
                inputValue,
                meta,
            };
        },

    };
</script>

<style lang="less" scoped>
    .custom-select-one {
        .p-dropdown {
            width: 100%;
            display: flex;
            justify-content: space-between;
        }
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
</style>
